import { cx, styled } from "simplydo/react/styled";

import type { PlaceholderProps } from "./Placeholder.types";
import { PlaceholderImage } from "./PlaceholderImage";
import { PlaceholderLine } from "./PlaceholderLine";

const Root = styled.div`
  display: flex;
  gap: 1em;
  width: 100%;
  position: relative;
  overflow: hidden;

  ${PlaceholderLine}, ${PlaceholderImage} {
    &:only-child {
      margin: 0;
    }
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }

    animation-duration: 4s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: sdo-placeholder-shimmer;
    animation-timing-function: linear;
    background: rgba(0, 0, 0, 0.5);
    background: linear-gradient(
      to right,
      #f0f0f0bb 8%,
      #dededeee 18%,
      #f0f0f0bb 33%
    );
    background-size: 2000px 100%;
    background-rotation: 45deg;
    min-height: 1em;

    @keyframes sdo-placeholder-shimmer {
      0% {
        background-position: -1000px 0;
      }
      100% {
        background-position: 1000px 0;
      }
    }
  }
`;

const PlaceholderComponent = (props: PlaceholderProps) => {
  const { children, className, style } = props;
  return (
    <Root className={cx(className)} style={style}>
      {children}
    </Root>
  );
};

export const Placeholder = styled(PlaceholderComponent)``;
